import './Auth.scss'
import Login from '../../components/login-components/Login'
import house from '../../assets/walpaper4.jpg'
import Register from '../../components/login-components/Register'
import { useState } from 'react'

const Auth = () => {

  const [ isLogIn, setIsLogIn ] = useState(true)

  const toggleLogin = () => {
    setIsLogIn(prevState => !prevState)
  }

  return (
    <div className='login-register-page'>
      <img className="background-image" src={house} alt=" background" />
      <div className="login-register-container">
        {isLogIn ? <Login toggleLogin={toggleLogin} isLogIn={isLogIn}/> :
         <Register toggleLogin={toggleLogin}/>}
      </div>
    </div>
  )
}

export default Auth
